/* eslint-disable react/no-array-index-key */
/* eslint-disable arrow-body-style */
import {
  Stack,
  TextField,
  Button,
  Container,
  Typography,
  Paper,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  LinearProgress,
  FormControl,
  Autocomplete,
  Collapse,
  Snackbar,
  Alert,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Radio,
  RadioGroup
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import LockResetIcon from '@mui/icons-material/LockReset';
import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DownloadIcon from '@mui/icons-material/Download';
import moment from 'moment';
import XLSXS from 'xlsx-js-style';
import 'jspdf-autotable';
import { ReactComponent as MastersIcon } from '../media/filter.svg';
import axios from '../axiosConfig';

// table header cell styles
const StyledTableCell = styled(TableCell)({
  color: 'white',
  fontWeight: '800',
  backgroundColor: '#219C90',
  padding: 'none',
  whiteSpace: 'nowrap',
});

const StyledTableCell2 = styled(TableCell)({
  color: '#006769',
  fontWeight: '800',
  backgroundColor: '#EEEDEB',
  padding: 'none',
  whiteSpace: 'nowrap',
  // textAlign:'center'
});

// Set the initial state for fromDate and toDate
const formatDateToinitialValues = (date) => {
  if (!date) {
    return '';
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
// Get the current date and 30 days before the current date
const currentDate = new Date();
const fromDateOnCurrentMonth = new Date(currentDate);
fromDateOnCurrentMonth.setDate(1);
const initialFromDate = formatDateToinitialValues(fromDateOnCurrentMonth);
const initialToDate = formatDateToinitialValues(currentDate);

const currentYear = new Date().getFullYear();
const selectedYears = Array.from({ length: 10 }, (_, i) => {
  const year = currentYear - i;
  return `${year}`;
});

const MonthWiseProductionReport = () => {
  // eslint-disable-next-line no-restricted-globals
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';
  const [fromDate, setfromDate] = useState(initialFromDate);
  const [toDate, setToDate] = useState(initialToDate);

  const [selectedYear, setSelectedYear] = useState(selectedYears[0]);
  const [buyerData, setbuyerData] = useState([]);
  const [buyerSelected, setbuyerSelected] = useState({
    Buyer_Id: '0',
    Buyer_Name: 'All',
  });

  const [styleData, setStyleData] = useState([]);
const [styleSelected, setStyleSelected] = useState({
  Srhid: '0',
  StyleDescription: 'All',
});

const [styleDesc, setStyleDesc] = useState([]);

  const [reportData, setreportData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const groupedPaymentsByName = {};

  const resetFilters = () => {
    setfromDate(initialFromDate);
    setToDate(initialToDate);
    setbuyerSelected({ Buyer_Id: '0', Buyer_Name: 'All' });
    setStyleSelected({ Srhid: '0', StyleDescription: 'All' });
    setFilteredData([]);
  };

  // other states
  const [openLoader, setOpenLoader] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showNoResultsSnackbar, setShowNoResultsSnackbar] = useState(false);
  const noResultsMessage = 'No results found for the applied filters.';
  const [expanded, setExpanded] = React.useState(true);
  // pagination
  const totalRows = filteredData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const currentPage = Math.max(0, Math.min(page, totalPages - 1));

  // for radio button
 const [userTypeFilter, setUserTypeFilter] = useState('Buyer Wise');



   const [apiConfig] = useState({
     companyId: sessionStorage.getItem('CompanyId'),
     unitId: sessionStorage.getItem('factoryID'),
     fiscalYear: sessionStorage.getItem('FiscalYear'),
   });

  // API Integration
  useEffect(() => {
    GetAllActiveBuyers();
    formatDateToinitialValues();
    // getAllData();
  }, []);

  useEffect(() => {
  if (userTypeFilter === 'Style Wise') {
    getAllStyles();  
  }
}, [userTypeFilter]);


  // get all Cities Request
  const getAllData = async () => {
    // setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetallPaymentsForMIS', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setreportData(res.data);
      // console.log('all data recieved: ', res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleselectedYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  // get all unit data
  const GetAllActiveBuyers = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveBuyers', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setbuyerData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  reportData.forEach((payment) => {
    const fullName = `${payment.FirstName} ${payment.LastName}`;
    if (!groupedPaymentsByName[fullName]) {
      groupedPaymentsByName[fullName] = [];
    }
    groupedPaymentsByName[fullName].push(payment);
  });

  const getAllStyles = async () => {
     setOpenLoader(true);
     try {
       const res = await axios.instance.get(
         `/GetStyleDetails/${apiConfig.companyId}/${apiConfig.unitId}/${apiConfig.fiscalYear}/Y`,
         // '/getAllDailyStyles',
         {
           headers: { Authorization: tokent, 'Content-Type': 'application/json' },
         }
       );
       setStyleData(res.data);
       const uniqueStyles = filterUniqueByDescription(res.data);
       setStyleDesc(uniqueStyles);
       setOpenLoader(false);
     } catch (error) {
       console.error('Error fetching data:', error);
     }
   };


     const filterUniqueByDescription = (data) => {
  const seen = new Map(); // Use Map to track the first occurrence
  const uniqueItems = [];
  
  // Sort by Obref descending (or ObNo if you prefer) to keep the newest/highest
  const sortedData = [...data].sort((a, b) => Number(b.Obref) - Number(a.Obref));
  
  sortedData.forEach(item => {
    const description = item.StyleDescription.trim();
    if (!seen.has(description)) {
      seen.set(description, true);
      uniqueItems.push(item);
    }
  });
  // Sort back by Obref if needed
  return uniqueItems;
};

  const applyFiltersDate = async () => {
    try {
      const res = await axios.instance.get(`/getMonthlyProduction/${buyerSelected.Buyer_Id}/${fromDate}/${toDate}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setFilteredData(res.data);
      setPage(0);
      setOpenLoader(false);
      setExpanded(false);
      if (res.data.length === 0) {
        setShowNoResultsSnackbar(true);
      } else {
        setShowNoResultsSnackbar(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

 const applyFilters = async () => {
  try {
    let res;

    if (userTypeFilter === 'Buyer Wise') {
      //  Buyer Wise API
      res = await axios.instance.get(
        `/GetAllMonthlyProductionOnYear/${buyerSelected.Buyer_Id}/${selectedYear}`,
        {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        }
      );
    } else {
      //  Style Wise API
      res = await axios.instance.post(
        `/GetStyleWiseMonthlyProduction`,
        { Year: selectedYear ,
          StyleDescription: styleSelected.StyleDescription
        }, 
        {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        }
      );
    }

    setFilteredData(res.data);
    setPage(0);
    setOpenLoader(false);
    // setExpanded(false);

    if (res.data.length === 0) {
      setShowNoResultsSnackbar(true);
    } else {
      setShowNoResultsSnackbar(false);
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

  

  const downloadPDF = async () => {
    setOpenLoader(true);
    try {
      // const res = await axios.instance.get(`/getMonthlyProductionpdf/${buyerSelected.Buyer_Id}/${fromDate}/${toDate}`, {
      const res = await axios.instance.get(`/getMonthlyProductionpdf/${buyerSelected.Buyer_Id}/${selectedYear}`, {
        responseType: 'blob', // Important: Handle the response as a Blob
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });

      // Create a link element, use it to download the file
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'MonthwiseProduction.pdf'); // Specify the filename
      document.body.appendChild(link);
      link.click();

      // Clean up and remove the link
      document.body.removeChild(link);

      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setOpenLoader(false);
    }
  };

  const handleCloseSnackbar = () => {
    setShowNoResultsSnackbar(false);
  };

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  const totals = filteredData.reduce((acc, curr) => {
    Object.keys(curr).forEach((key) => {
      if (key !== 'sno' && key !== 'Buyer_Name') {
        acc[key] = (acc[key] || 0) + curr[key];
      }
    });
    return acc;
  }, {});

 const exportToExcel = () => {
  if (filteredData.length === 0) return;

  const wb = XLSXS.utils.book_new();

  const title = 'Monthly Production Report';
  const currentDate = moment().format('DD-MM-YYYY');

  const filters = [
    `Type: ${userTypeFilter}`,
    `Year: ${selectedYear}`,
    userTypeFilter === 'Buyer Wise'
    ? `Buyer: ${buyerSelected?.Buyer_Name}`
    : `Style: ${styleSelected?.StyleDescription}`,
  ];

  let headers = [];

  if (userTypeFilter === 'Buyer Wise') {
    headers = [
      'S.No', 'Buyer',
      'Jan','Feb','Mar','Apr','May','Jun',
      'Jul','Aug','Sep','Oct','Nov','Dec',
      'Total'
    ];
  } else {
    headers = [
      'Style', 'Delivery Date', 'Order Qty',
      'Jan','Feb','Mar','Apr','May','Jun',
      'Jul','Aug','Sep','Oct','Nov','Dec',
      'Total'
    ];
  }

  const data = filteredData.map((row) => {
    if (userTypeFilter === 'Buyer Wise') {
      return {
        'S.No': row.sno,
        'Buyer': row.Buyer_Name,
        'Jan': row.Jan,
        'Feb': row.Feb,
        'Mar': row.Mar,
        'Apr': row.Apr,
        'May': row.May,
        'Jun': row.Jun,
        'Jul': row.Jul,
        'Aug': row.Aug,
        'Sep': row.Sep,
        'Oct': row.Oct,
        'Nov': row.Nov,
        'Dec': row.Dec,
        'Total': row.Total,
      };
    }

    return {
      'Style': row.StyleDescription,
      'Delivery Date': row.DeliveryDate,
      'Order Qty': row.OrderQty,
      'Jan': row.Jan,
      'Feb': row.Feb,
      'Mar': row.Mar,
      'Apr': row.Apr,
      'May': row.May,
      'Jun': row.Jun,
      'Jul': row.Jul,
      'Aug': row.Aug,
      'Sep': row.Sep,
      'Oct': row.Oct,
      'Nov': row.Nov,
      'Dec': row.Dec,
      'Total': row.Total,
    };
  });

  if (userTypeFilter === 'Buyer Wise') {
    data.push({
      'S.No': '',
      'Buyer': 'TOTAL',
      ...totals
    });
  } else {
    data.push({
      'Style': 'TOTAL',
      'Delivery Date': '',
      'Order Qty': '',
      ...totals
    });
  }

  const startRow = 6;


  const cleanData = data.map(row => {
    const newRow = {};
    headers.forEach(h => {
      newRow[h] = row[h] ?? '';
    });
    return newRow;
  });

  const ws = XLSXS.utils.json_to_sheet(cleanData, {
    origin: `A${startRow}`,
    header: headers,
    skipHeader: false
  });

  ws.A1 = {
    v: title,
    t: 's',
    s: {
      font: { bold: true, sz: 16, color: { rgb: 'FFFFFF' } },
      alignment: { horizontal: 'center' },
      fill: { fgColor: { rgb: 'FF219C90' } },
    },
  };


  ws.A2 = {
    v: `Generated on: ${moment().format('DD-MM-YYYY HH:mm:ss')}`,
    t: 's',
    s: { alignment: { horizontal: 'right' } },
  };

  ws.A3 = { v: filters[0], t: 's' };
  ws.A4 = { v: filters[1], t: 's' };
  ws.A5 = { v: filters[2], t: 's' };


  const lastColIndex = headers.length - 1;

  ws['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: lastColIndex } },
    { s: { r: 1, c: 0 }, e: { r: 1, c: lastColIndex } },
  ];


  const headerRowIndex = startRow - 1;

  headers.forEach((_, colIdx) => {
    const cellRef = XLSXS.utils.encode_cell({ r: headerRowIndex, c: colIdx });

    if (ws[cellRef]) {
      ws[cellRef].s = {
        font: { bold: true, color: { rgb: 'FFFFFF' } },
        fill: { fgColor: { rgb: 'FF134E5E' } },
        alignment: { horizontal: 'center' },
      };
    }
  });

 
  const totalRowIndex = startRow + cleanData.length - 1;

  if (!ws['!merges']) ws['!merges'] = [];

  ws['!merges'].push({
    s: { r: totalRowIndex, c: 0 },
    e: { r: totalRowIndex, c: userTypeFilter === 'Buyer Wise' ? 1 : 2 },
  });

  for (let col = 0; col < headers.length; col+=1) {
    const cellRef = XLSXS.utils.encode_cell({ r: totalRowIndex, c: col });

    if (ws[cellRef]) {
      ws[cellRef].s = {
        font: { bold: true, color: { rgb: 'FFFFFF' } },
        fill: { fgColor: { rgb: 'FF219C90' } },
        alignment: { horizontal: 'right' },
      };
    }
  }

  ws['!cols'] = headers.map(() => ({ wch: 14 }));


  XLSXS.utils.book_append_sheet(wb, ws, title);

  XLSXS.writeFile(
    wb,
    `${title.replace(/ /g, '_')}_${currentDate}.xlsx`
  );
};

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2, p: 1 }} elevation={3}>
        <Snackbar
          style={{ marginTop: '45px' }}
          open={showNoResultsSnackbar}
          autoHideDuration={4000}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          onClose={handleCloseSnackbar}
        >
          <Alert onClose={handleCloseSnackbar} severity="info" variant="filled" sx={{ width: '100%' }}>
            {noResultsMessage}
          </Alert>
        </Snackbar>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2} mb={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: 'linear-gradient(to right, #134e5e, #71b280)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Monthly Production Report
            </Typography>
          </Typography>
        </Grid>

        {/* filters */}
        <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, my: 2 }}>
          <Accordion
            expanded={expanded}
            onChange={handleExpansion}
            disableGutters
            sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: '#36BA98' }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderTop: 'none' }}
            >
              <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                <IconButton aria-label="ExpandMoreIcon" color="white">
                  <MastersIcon style={{ color: 'white', width: 24, height: 24 }} />
                </IconButton>
                <Typography
                  sx={{
                    color: '#36BA98',
                    '&.active': {
                      color: 'text.primary',
                      bgcolor: 'action.selected',
                      fontWeight: 'fontWeightBold',
                    },
                  }}
                  variant="h6"
                >
                  Filters
                </Typography>
              </Stack>
            </AccordionSummary>

            <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
              <Stack direction={'column'} justifyContent={'space-between'} spacing={2} my={1}>
                <Stack direction={{ sm: 'row', xs: 'column' }} spacing={1}>
                  <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                    {/* <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="From"
                        type="date"
                        value={fromDate}
                        min={'1000-01-01'}
                        max={'9999-12-31'}
                        onChange={(e) => {
                          if (e.target.value) setfromDate(e.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="To"
                        type="date"
                        value={toDate}
                        min={'1000-01-01'}
                        max={'9999-12-31'}
                        onChange={(e) => {
                          if (e.target.value) setToDate(e.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid> */}
                    
                            <Grid item xs="auto" sx={{ ml: 5 }}>
                              <FormControl component="fieldset">
                               <RadioGroup
  row
  value={userTypeFilter}
  onChange={(e) => {
    const value = e.target.value;
    setUserTypeFilter(value);
    setFilteredData([]);
    setbuyerSelected({ Buyer_Id: '0', Buyer_Name: 'All' });
    setStyleSelected({ Srhid: '0', StyleDescription: 'All' });
    setPage(0);
  }}
>
                                  <FormControlLabel
                                    value="Buyer Wise"
                                    control={<Radio size="small" />}
                                    label="Buyer Wise"
                                    sx={{ mr: 1 }}
                                    onClick={() => setFilteredData([])}
                                  />
                                  <FormControlLabel
                                    value="Style Wise"
                                    control={<Radio size="small" />}
                                    label="Style Wise"
                                    onClick={() => setFilteredData([])}
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Grid>

                    <Grid item lg={2} md={6} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="year-select-label">Year</InputLabel>
                        <Select
                          labelId="year-select-label"
                          id="year-select"
                          value={selectedYear}
                          size="small"
                          label="Year"
                          onChange={handleselectedYearChange}
                        >
                          {selectedYears.map((year) => (
                            <MenuItem key={year} value={year}>
                              {year}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                   {/* Buyer Dropdown */}
{userTypeFilter === 'Buyer Wise' && (
  <Grid item lg={4} md={6} xs={12}>
    <FormControl size="small" fullWidth>
      <Autocomplete
        size="small"
        fullWidth
        options={[{ Buyer_Name: 'All', Buyer_Id: '0' }, ...buyerData]}
        getOptionLabel={(obj) => obj.Buyer_Name || ''}
        isOptionEqualToValue={(option, value) =>
          option.Buyer_Id === value.Buyer_Id
        }
        renderInput={(params) => <TextField {...params} label="Buyer" />}
        value={buyerSelected}
        onChange={(e, newValue) => {
          setbuyerSelected(newValue);
        }}
        disableClearable
      />
    </FormControl>
  </Grid>
)}

{/* Style Dropdown */}
{userTypeFilter === 'Style Wise' && (
  <Grid item lg={4} md={6} xs={12}>
    <FormControl size="small" fullWidth>
      <Autocomplete
        size="small"
        fullWidth
        options={[{ StyleDescription: 'All', Srhid: '0' }, ...styleDesc]}
        getOptionLabel={(obj) => obj.StyleDescription || ''}
        isOptionEqualToValue={(option, value) =>
          option.Srhid === value.Srhid
        }
        renderInput={(params) => <TextField {...params} label="Style Description" />}
        value={styleSelected}
        onChange={(e, newValue) => {
          setStyleSelected(newValue);
        }}
        disableClearable
      />
    </FormControl>
  </Grid>
)}
                    <Grid item xs={12}>
  <Stack direction="row" justifyContent="flex-end" spacing={1}>

    {/* Buyer Wise → Show PDF */}
    {userTypeFilter === 'Buyer Wise' && (
      <Button
        variant="outlined"
        startIcon={<PictureAsPdfIcon />}
        onClick={downloadPDF}
        color="error"
        aria-label="Download as PDF"
      >
        PDF
      </Button>
    )}

    {/* Style Wise → Show Excel */}
    {userTypeFilter === 'Style Wise' && (
      <Button
        variant="contained"
        size="medium"
        color="success"
        startIcon={<DownloadIcon />}
        sx={{ boxShadow: 0 }}
        onClick={exportToExcel}
        disabled={filteredData.length === 0}
      >
        Export Excel
      </Button>
    )}

    <Button
      variant="contained"
      color="secondary"
      onClick={applyFilters}
      startIcon={<FilterAltIcon />}
    >
      Apply Filters
    </Button>

    <Button
      variant="contained"
      color="warning"
      onClick={resetFilters}
      startIcon={<LockResetIcon />}
    >
      Reset
    </Button>

  </Stack>
</Grid>
                  </Grid>
                </Stack>
              </Stack>
            </AccordionDetails>
          </Accordion>
        </Stack>

        <Collapse in={filteredData.length > 0}>
  <>
    {userTypeFilter === 'Buyer Wise' ? (
      /* table  */
      <TableContainer sx={{ borderRadius: 1, backgroundColor: 'inherit' }} elevation={4} component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ padding: 'none' }}>
              <StyledTableCell align="center">S.No</StyledTableCell>
              <StyledTableCell align="left">Buyer</StyledTableCell>
              <StyledTableCell align="center">Jan</StyledTableCell>
              <StyledTableCell align="center">Feb</StyledTableCell>
              <StyledTableCell align="center">Mar</StyledTableCell>
              <StyledTableCell align="center">Apr</StyledTableCell>
              <StyledTableCell align="center">May</StyledTableCell>
              <StyledTableCell align="center">Jun</StyledTableCell>
              <StyledTableCell align="center">Jul</StyledTableCell>
              <StyledTableCell align="center">Aug</StyledTableCell>
              <StyledTableCell align="center">Sep</StyledTableCell>
              <StyledTableCell align="center">Oct</StyledTableCell>
              <StyledTableCell align="center">Nov</StyledTableCell>
              <StyledTableCell align="center">Dec</StyledTableCell>
              <StyledTableCell align="center">Total</StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {(rowsPerPage > 0
              ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : filteredData
            ).map((enq, index) => (
              <TableRow key={index} hover>
                <TableCell
                  align="center"
                  padding="normal"
                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                >
                  {enq.sno}
                </TableCell>
                <TableCell
                  align="left"
                  padding="normal"
                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                >
                  {enq.Buyer_Name}
                </TableCell>
                <TableCell
                  align="center"
                  padding="normal"
                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                >
                  {enq.Jan}
                </TableCell>
                <TableCell
                  align="center"
                  padding="normal"
                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                >
                  {enq.Feb}
                </TableCell>
                <TableCell
                  align="center"
                  padding="normal"
                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                >
                  {enq.Mar}
                </TableCell>
                <TableCell
                  align="center"
                  padding="normal"
                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                >
                  {enq.Apr}
                </TableCell>
                <TableCell
                  align="center"
                  padding="normal"
                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                >
                  {enq.May}
                </TableCell>
                <TableCell
                  align="center"
                  padding="normal"
                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                >
                  {enq.Jun}
                </TableCell>
                <TableCell
                  align="center"
                  padding="normal"
                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                >
                  {enq.Jul}
                </TableCell>
                <TableCell
                  align="center"
                  padding="normal"
                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                >
                  {enq.Aug}
                </TableCell>
                <TableCell
                  align="center"
                  padding="normal"
                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                >
                  {enq.Sep}
                </TableCell>
                <TableCell
                  align="center"
                  padding="normal"
                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                >
                  {enq.Oct}
                </TableCell>
                <TableCell
                  align="center"
                  padding="normal"
                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                >
                  {enq.Nov}
                </TableCell>
                <TableCell
                  align="center"
                  padding="normal"
                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                >
                  {enq.Dec}
                </TableCell>
                <TableCell
                  align="center"
                  padding="normal"
                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                >
                  {enq.Total}
                </TableCell>
              </TableRow>
            ))}
            <TableRow hover>
              <StyledTableCell2
                align="right"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                colSpan={2}
              >
                Total
              </StyledTableCell2>

              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Jan}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Feb}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Mar}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Apr}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.May}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Jun}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Jul}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Aug}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Sep}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Oct}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Nov}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Dec}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Total}
              </StyledTableCell2>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    ) : (
      <TableContainer
        sx={{ borderRadius: 1, backgroundColor: 'inherit' }}
        elevation={4}
        component={Paper}
      >
        <Table size="small">
          <TableHead>
            <TableRow>
              <StyledTableCell align="left">Style</StyledTableCell>
              <StyledTableCell align="center">Delivery Date</StyledTableCell>
              <StyledTableCell align="center">Order Qty</StyledTableCell>

              <StyledTableCell align="center">Jan</StyledTableCell>
              <StyledTableCell align="center">Feb</StyledTableCell>
              <StyledTableCell align="center">Mar</StyledTableCell>
              <StyledTableCell align="center">Apr</StyledTableCell>
              <StyledTableCell align="center">May</StyledTableCell>
              <StyledTableCell align="center">Jun</StyledTableCell>
              <StyledTableCell align="center">Jul</StyledTableCell>
              <StyledTableCell align="center">Aug</StyledTableCell>
              <StyledTableCell align="center">Sep</StyledTableCell>
              <StyledTableCell align="center">Oct</StyledTableCell>
              <StyledTableCell align="center">Nov</StyledTableCell>
              <StyledTableCell align="center">Dec</StyledTableCell>

              <StyledTableCell align="center">Total</StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {(rowsPerPage > 0
              ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : filteredData
            ).map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.StyleDescription}</TableCell>
                <TableCell align="center">{row.DeliveryDate}</TableCell>
                <TableCell align="center">{row.OrderQty}</TableCell> 

                <TableCell align="center">{row.Jan}</TableCell>
                <TableCell align="center">{row.Feb}</TableCell>
                <TableCell align="center">{row.Mar}</TableCell>
                <TableCell align="center">{row.Apr}</TableCell>
                <TableCell align="center">{row.May}</TableCell>
                <TableCell align="center">{row.Jun}</TableCell>
                <TableCell align="center">{row.Jul}</TableCell>
                <TableCell align="center">{row.Aug}</TableCell>
                <TableCell align="center">{row.Sep}</TableCell>
                <TableCell align="center">{row.Oct}</TableCell>
                <TableCell align="center">{row.Nov}</TableCell>
                <TableCell align="center">{row.Dec}</TableCell>

                <TableCell align="center">{row.Total}</TableCell>
              </TableRow>
            ))}
            <TableRow hover>
              <StyledTableCell2
                align="right"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                colSpan={3}
              >
                Total
              </StyledTableCell2>

              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Jan}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Feb}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Mar}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Apr}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.May}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Jun}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Jul}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Aug}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Sep}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Oct}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Nov}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Dec}
              </StyledTableCell2>
              <StyledTableCell2
                align="center"
                padding="normal"
                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
              >
                {totals.Total}
              </StyledTableCell2>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    )}

    {/* pagination */}
    <TablePagination
      rowsPerPageOptions={[5, 10, 25]}
      component="div"
      count={totalRows}
      rowsPerPage={rowsPerPage}
      page={currentPage} // Use the calculated currentPage value
      onPageChange={(event, newPage) => setPage(newPage)}
      onRowsPerPageChange={(event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset the page when rowsPerPage changes
      }}
      mt={2}
    />
  </>
</Collapse>
      </Container>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>
    </>
  );
};

export default MonthWiseProductionReport;
